export enum FichaCadastroTipo {
    NOVA,
    ALTERACAO_VEICULO,
    CORRECAO_FIPE_NOT_FOUND,
    CORRECAO_PLACA_INVALIDA,
}
